import React from 'react';
import AccordionItem from './AccordionItem';

const Accordion = ({ values }) => {
    return (
        <div className="faq__outer">
            <div className="faq__inner">
                <h2 className="faq__heading">{values.title}</h2>
                <div className="faq__description" dangerouslySetInnerHTML={{ __html: values.description }}></div>
                <div className="faq__accordion">
                    {values.items.map((item, index) => {
                        return (
                            <AccordionItem key={index} text={item.text} title={item.title} />
                        )
                    })}
                </div>
            </div>
        </div>
    )

}

export default Accordion;